var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-white btn-pill",class:_vm.icon == 'trash' ? 'text-danger' : '',attrs:{"type":"button"},domProps:{"innerHTML":_vm._s(_vm.ic(_vm.icon))},on:{"click":_vm.action}})
}
var staticRenderFns = []

export { render, staticRenderFns }